import React from 'react'
import Header from '../components/Header';
import Gallery from '../components/Gallery'

const Home = () => {
  return (
    <>
    <Header />
    <Gallery/>
    </>
  )
}

export default Home